module.exports = __webpack_public_path__ + "ptc_momoro_O2.de0a514d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_O2.jpg
// module id = y4Os
// module chunks = 0